var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstWhale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 326,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#firstWhale_svg__clip0_632_7648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.567 77.806s-.543 18.873-11.294 27.973c-10.747 9.1-29.485 13.306-39.35 30.193-7.409 12.689-10.212 65.532 59.583 54.851 53.156-8.135 79.442-19.956 85.613-80.36 2.16-21.124-10.729-55.558-10.729-55.558l-83.831 22.901h.008z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.679 65.791s-3.273-4.42-8.061-2.316c-4.663 2.047-2.221 25.005 10.399 30.376",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.679 65.791s-3.273-4.42-8.061-2.316c-4.663 2.047-2.221 25.005 10.399 30.376",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.538 159.074c3.503-3.933 6.036-7.957 7.848-11.716 4.78-9.891 4.676-17.987 4.676-17.987s-16.817-9.347-23.675-34.274c-2.29-8.326-4.367-18.069-5.084-27.976-1.443-19.769 2.507-40.163 20.981-51.157 27.72-16.513 64.488 4.046 66.044 28.977.361 5.827.257 12.341-.109 19.116-1.138 21.671-4.814 46.029-3.628 59.087.387 4.272 2.455 8.691 1.36 12.837-18.156 68.6-72.889 28.116-68.413 23.097v-.004z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.733 156.388l-23.831 11.09a87.686 87.686 0 00-49.001 62.377L53 349.898h259.39l-13.733-106.584a97.678 97.678 0 00-52.434-74.506l-27.607-14.106-38.024 14.206-30.854-.365v-5.927",
    fill: "#FF755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.138 119.091s-15.579 18.694-37.076 10.281M152.467 59.502s6.453 27.79-2.59 41.488a.864.864 0 00.634 1.338l9.317.987M161.61 76.124s7.679-8.852 17.8-2.716",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.226 73.912c-.022 2.147-1.386 3.876-3.055 3.86-1.669-.018-3.003-1.77-2.981-3.916.021-2.147 1.377-2.825 3.046-2.808 1.669.018 3.011.717 2.99 2.864z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.418 79.132s6.623-8.492 17.604-3.116",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.673 76.62c.144 2.142-1.09 3.967-2.75 4.08-1.665.113-3.129-1.534-3.273-3.676-.143-2.143 1.161-2.92 2.825-3.033 1.664-.113 3.059.486 3.203 2.629h-.005zM212.214 64.057c-19.39-.956-31.589-26.048-31.589-26.048-9.208 14.475-42.608 25.391-55.328 29.116-1.443-19.769 2.507-40.163 20.981-51.157 27.72-16.513 64.489 4.046 66.044 28.977.361 5.827.257 12.341-.108 19.116v-.004z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.669 60.789s9.508-14.736 17.174-7.944c9.23 8.178 2.568 30.58-10.747 39.723",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.669 60.789s9.508-14.736 17.174-7.944c9.23 8.178 2.568 30.58-10.747 39.723",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.029 70.601s1.986-5.14 8.878-7.126M209.597 80.418l2.559-15.331M148.755 64.53s-8.009-2.43-17.309 6.71",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.498 96.566c7.34-.491 12.787-8.406 12.166-17.678-.621-9.272-7.074-16.39-14.413-15.9-7.34.492-12.787 8.407-12.166 17.679.621 9.272 7.074 16.39 14.413 15.899zM140.184 99.27c7.34-.49 12.786-8.406 12.166-17.678-.621-9.272-7.074-16.39-14.414-15.899-7.34.492-12.786 8.407-12.166 17.679.621 9.272 7.074 16.39 14.414 15.899zM152.394 83.192l5.405-.322M183.917 74.561l15.753-15.387",
    stroke: "#FF755F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.625 159.282l12.107-16.826 19.055 24.535 42.679-32.588 7.144 20.299-38.689 36.125-11.429-21.498-10.69 21.498-20.177-31.545z",
    fill: "#FF755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.484 233.445l-11.472 116.458M159.175 62.857s7.574-7.949 24.739.552",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.083 250.157l11.924-5.906 80.881 14.367 1.682 59.921h-12.716l-3.433-52.712-78.338-15.67z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.617 249.939l12.385-5.688 80.763 14.366M202.563 315.937l-1.734-57.384M110.615 306.202l-2.921-55.954 79.981 15.579 1.743 50.175",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.141 349.903l-3.446-99.654 79.981 15.579 3.559 84.075h-80.094z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.478 268.509l1.79 43.886M196.842 270.812l1.008 24.627M118.589 248.02l67.192 13.149M138.828 161.859l18.973 28.968 10.986-20.155 10.959 21.572 33.47-32.505",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.913 111.937s2.347-3.438 6.718-2.195c4.363-4.558 5.993 1.147 14.741-3.628-10.73 15.261-21.459 5.823-21.459 5.823z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.855 321.413s-38.998.435-37.034-13.51c-4.958-5.776 1.07-11.125 1.07-11.125s-3.447-7.457 2.12-11.46c.521-3.137-.465-4.736 2.003-7.148 1.269-1.243 3.225-1.456 4.776-.591 6.175 3.433 5.736 2.151 5.736 2.151l-.995-3.177a7.89 7.89 0 00-2.707-3.885c-.656-.508-1.578-1.312-2.455-2.107-1.978-1.786-1.026-5.072 1.603-5.528.969-.169 1.96-.182 2.799-.043 3.937.647 9.36 2.259 12.259 6.275 4.893 6.775 14.384 17.039 14.384 17.039l13.149 4.38-.717 24.184-15.987 4.545h-.004z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.953 301.418s-4.232-1.877-5.062-4.645l5.062 4.645z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.953 301.418s-4.232-1.877-5.062-4.645",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.015 289.659s-4.233-1.877-5.063-4.646l5.063 4.646z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.015 289.659s-4.233-1.877-5.063-4.646",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.059 311.765s-3.772-2.39-5.71-4.454l5.71 4.454z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.059 311.765s-3.772-2.39-5.71-4.454",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.478 313.182l-92.501-28.086-13.297 53.656 37.911 11.151h72.076l-4.189-36.721z",
    fill: "#FF755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.706 315.937l-97.729-30.841-13.297 53.656 37.911 11.151M233.046 273.415v39.48",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 49.019,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#9EE1DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.427 65.063a5 5 0 015.145 0l6.682 4.009a.5.5 0 01-.017.866l-6.828 3.756a5 5 0 01-4.819 0l-6.828-3.756a.5.5 0 01-.016-.866l6.681-4.01zm6.174-1.715l6.682 4.009c1.654.992 1.608 3.404-.082 4.334l-6.828 3.755a7 7 0 01-6.747 0l-6.828-3.755c-1.69-.93-1.735-3.342-.081-4.334l6.681-4.01a7 7 0 017.203 0z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 69.52a1 1 0 012 0v5a1 1 0 11-2 0v-5z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 72.02v5a5 5 0 005 5h2a5 5 0 005-5v-5h2v5a7 7 0 01-7 7h-2a7 7 0 01-7-7v-5h2z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 0.019,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#9EE1DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.907 20.312a1 1 0 010 1.414l-5.6 5.6a1 1 0 01-1.407.008l-2.6-2.546a1.001 1.001 0 011.4-1.429l1.893 1.853 4.9-4.9a1 1 0 011.414 0z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247 12.519a1 1 0 00-2 0v.642c-.453.077-.872.2-1.27.403a4.997 4.997 0 00-2.185 2.185c-.302.592-.428 1.233-.487 1.961-.058.708-.058 1.582-.058 2.666v7.286c0 1.084 0 1.958.058 2.666.059.729.185 1.369.487 1.961a4.997 4.997 0 002.185 2.185c.592.302 1.233.428 1.961.487.708.058 1.582.058 2.666.058h5.286c1.084 0 1.958 0 2.666-.058.728-.06 1.369-.185 1.961-.487a4.997 4.997 0 002.185-2.185c.302-.592.428-1.233.487-1.961.058-.708.058-1.582.058-2.666v-7.286c0-1.084 0-1.958-.058-2.666-.059-.728-.185-1.369-.487-1.96a4.997 4.997 0 00-2.185-2.186 4.371 4.371 0 00-1.27-.403v-.642a1 1 0 00-2 0v.505c-.411-.005-.862-.005-1.357-.005H252v-.5a1 1 0 00-2 0v.5h-1.643c-.494 0-.946 0-1.357.005v-.505zm8 2.506c-.402-.006-.862-.006-1.4-.006H252v.5a1 1 0 01-2 0v-.5h-1.6c-.538 0-.998 0-1.4.006v.494a1 1 0 01-2 0v-.312c-.141.04-.258.086-.362.139a3.004 3.004 0 00-1.311 1.311c-.134.263-.226.611-.276 1.216-.05.617-.051 1.41-.051 2.546v7.2c0 1.137.001 1.929.051 2.546.05.605.142.953.276 1.216a3.004 3.004 0 001.311 1.311c.263.134.611.226 1.216.276.617.05 1.409.051 2.546.051h5.2c1.137 0 1.929 0 2.546-.051.605-.05.953-.142 1.216-.276a3.004 3.004 0 001.311-1.311c.134-.263.226-.611.276-1.216.05-.617.051-1.41.051-2.546v-7.2c0-1.137-.001-1.929-.051-2.546-.05-.605-.142-.953-.276-1.216a3.004 3.004 0 00-1.311-1.311 1.964 1.964 0 00-.362-.14v.313a1 1 0 01-2 0v-.494z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 95.019,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#C3DCF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294 113.519c0 3.039-2.461 5.5-5.5 5.5a5.498 5.498 0 01-5.5-5.5c0-3.038 2.461-5.5 5.5-5.5s5.5 2.462 5.5 5.5zm-2 0c0-1.934-1.566-3.5-3.5-3.5a3.499 3.499 0 00-3.5 3.5c0 1.934 1.566 3.5 3.5 3.5s3.5-1.566 3.5-3.5zM279.5 125.662c0-3.88 4.299-5.643 9.25-5.643s9.25 1.763 9.25 5.643c0 2.016-.781 2.857-2.456 2.857h-13.588c-1.675 0-2.456-.841-2.456-2.857zm2.056.821c-.064-.055-.063-.188-.059-.5.002-.091.003-.197.003-.321 0-2.288 3.304-3.643 7.25-3.643s7.25 1.355 7.25 3.643c0 .124.001.23.003.321.004.312.005.445-.059.5-.048.041-.131.039-.276.037l-.124-.001h-13.588l-.124.001c-.145.002-.228.004-.276-.037z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.707 114.812a.999.999 0 00-1.414 0l-4.593 4.593-1.993-1.993-.094-.083a1 1 0 00-1.32 1.497l2.7 2.7.094.083a1 1 0 001.32-.083l5.3-5.3.083-.094a1 1 0 00-.083-1.32z",
    fill: "#333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "firstWhale_svg__clip0_632_7648"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h336v326H0z"
  })))));
}
export default __webpack_public_path__ + "static/firstWhale.3903ca49.svg";
export { SvgFirstWhale as ReactComponent };